export default __webpack_public_path__ + "static/media/bootstrap.6b8a49b2.png";